import React from "react";
import TrackreturnDetails from "../Components/OrderDetails/TrackreturnDetails";
import Breadcrumb from "../Components/Breadcrumb";
import Relatedproducts from "../Components/Productdetails/Relatedproducts";
import { useEffect } from 'react';
function TrackreturnDetailspage() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Breadcrumb
        title_1="Your Account"
        title_2="Orders"
        title_3="Track Return"
      />
      <TrackreturnDetails />
      <Relatedproducts />
    </>
  );
}

export default TrackreturnDetailspage;
